import Reveal from "@/pages/home/components/Reveal";
import SectionTitle from "@/pages/home/components/SectionTitle";
import { coverPicks } from "@/mocks/home";

export default function CoverPicks() {
  return (
    <section id="picks" className="bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <Reveal>
          <SectionTitle
            kicker="封面精选"
            title="本期值得一看的六张封面"
            desc="从近期的观影话题里挑出六部代表作品，封面统一了暖色杂志质感。访问畅通之后，可以拿它们当作你的第一晚片单。"
          />
        </Reveal>

        <div className="mt-10 grid grid-cols-2 gap-4 md:grid-cols-3 lg:grid-cols-6 lg:gap-5">
          {coverPicks.map((pick, index) => (
            <Reveal key={pick.title} delay={index * 60}>
              <article className="group flex h-full flex-col overflow-hidden rounded-xl border border-background-200/80 bg-background-100/60">
                <div className="relative overflow-hidden">
                  <img
                    src={pick.image}
                    alt={`${pick.title} 封面`}
                    title={`${pick.title} ${pick.category} 观影推荐`}
                    className="h-52 w-full object-top transition-transform duration-500 group-hover:scale-105 md:h-64"
                  />
                  <span className="absolute left-3 top-3 rounded-full bg-foreground-950/75 px-2.5 py-1 text-[10px] font-medium text-background-50">
                    {pick.category}
                  </span>
                  <span className="absolute right-3 top-3 inline-flex items-center gap-1 rounded-full bg-primary-500 px-2 py-1 text-[10px] font-bold text-background-50">
                    <i className="ri-star-fill text-[10px]" aria-hidden="true"></i>
                    {pick.rating}
                  </span>
                </div>
                <div className="flex flex-1 flex-col p-4">
                  <h3 className="font-heading text-sm font-bold text-foreground-950">{pick.title}</h3>
                  <p className="mt-2 flex-1 text-xs leading-relaxed text-foreground-600">{pick.desc}</p>
                  <span className="mt-3 inline-flex items-center gap-1 text-xs font-medium text-primary-700">
                    <i className="ri-play-circle-line text-sm" aria-hidden="true"></i>
                    加入片单
                  </span>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}